import { render } from "./index.vue?vue&type=template&id=68d0385b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=68d0385b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d0385b"],['__file',"src/vab/components/VabSideBarFooter/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68d0385b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68d0385b', __exports__)) {
    api.reload('68d0385b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=68d0385b&scoped=true", () => {
    api.rerender('68d0385b', render)
  })

}


export default __exports__